export default {
  pages: [
    {
      name: "Trouwjurken",
      filterGroups: [
        {
          name: "Silhouet",
          type: "checkbox",
          expanded: true,
          items: [
            {
              name: "A-lijn",
              image: "",
            },
            {
              name: "Prinses",
              image: "",
            },
            {
              name: "Zeemeermin",
              image: "",
            },
            {
              name: "Trumpet",
              image: "",
            },
            {
              name: "Soepelvallend",
              image: "",
            },
            {
              name: "Kort",
              image: "",
            },
          ],
        },
        {
          name: "Stijl",
          type: "checkbox",
          expanded: true,
          items: [
            {
              name: "Klassiek",
              image: "",
            },
            {
              name: "Romantisch",
              image: "",
            },
            {
              name: "Modern",
              image: "",
            },
            {
              name: "Vintage",
              image: "",
            },
            {
              name: "Bohemian",
              image: "",
            },
          ],
        },
        {
          name: "Maat",
          type: "checkbox",
          expanded: true,
          items: [
            {
              name: "Plus size",
              image: "",
            },
          ],
        },
        {
          name: "Details",
          type: "checkbox",
          items: [
            {
              name: "Kant",
              image: "",
            },
            {
              name: "Glitters",
              image: "",
            },
            {
              name: "Split",
              image: "",
            },
            {
              name: "3D bloemen",
              image: "",
            },
            {
              name: "Bijzonder rugpand",
              image: "",
            },
            {
              name: "Diep decolleté",
              image: "",
            },
            {
              name: "Lage rug",
              image: "",
            },
            {
              name: "Tatoeage-effect",
              image: "",
            },
            {
              name: "Tule",
              image: "",
            },
            {
              name: "Strapless",
              image: "",
            },
          ],
        },
        {
          name: "Merk",
          type: "checkbox",
          items: [
            {
              name: "Adore",
              image: "",
            },
            {
              name: "Essense of Australia",
              image: "",
            },
            {
              name: "E&R Special",
              image: "",
            },
            {
              name: "Hervé Paris",
              image: "",
            },
            {
              name: "Justin Alexander",
              image: "",
            },
            {
              name: "Ladybird",
              image: "",
            },
            {
              name: "Lilian West",
              image: "",
            },
            {
              name: "Linea Raffaelli",
              image: "",
            },
            {
              name: "Madam Burcu",
              image: "",
            },
            {
              name: "Milla Nova",
              image: ""
            },
            {
              name: "Nicole Colet",
              image: "",
            },
            {
              name: "Nicole Milano",
              image: "",
            },
            {
              name: "Sincerity",
              image: "",
            },
            {
              name: "Stella York",
              image: "",
            },
            {
              name: "Jarice",
              image: "",
            },
            {
              name: "Le Papillion",
              image: "",
            },
            {
              name: "Modeca",
              image: "",
            },
            {
              name: "Maggie Sottero",
              image: "",
            },
            {
              name: "Pronovias",
              image: "",
            },
          ],
        },
        {
          name: "Prijs",
          type: "checkbox",
          items: [
            {
              name: "Minder dan €995",
              image: "",
            },
            {
              name: "€996 - €1395",
              image: "",
            },
            {
              name: "€1396 - €1895",
              image: "",
            },
            {
              name: "€1896 - €2395",
              image: "",
            },
            {
              name: "€2396 - €2995",
              image: "",
            },
            {
              name: "Meer dan €2995",
              image: "",
            }
          ]
        },
        {
          name: "Accessoires (bruid)",
          type: "checkbox",
          items: [
            {
              name: "Haaraccessoires",
              image: "",
            },
            {
              name: "Armbanden",
              image: "",
            },
            {
              name: "Oorbellen",
              image: "",
            },
            {
              name: "Kettingen",
              image: "",
            },
            {
              name: "Sluiers",
              image: "",
            },
            {
              name: "Schoenen",
              image: "",
            },
            {
              name: "Overig",
              image: "",
            },
          ],
        },
      ],
    },
    {
      name: "Herencollectie",
      filterGroups: [
        {
          name: "Kleur",
          type: "checkbox",
          expanded: true,
          items: [
            {
              name: "Wit",
              image: "",
            },
            {
              name: "Roze",
              image: "",
            },
            {
              name: "Bordeaux",
              image: "",
            },
            {
              name: "Paars",
              image: "",
            },
            {
              name: "Patroon",
              image: "",
            },
            {
              name: "Beige",
              image: "",
            },
            {
              name: "Blauw",
              image: "",
            },
            {
              name: "Bruin",
              image: "",
            },
            {
              name: "Grijs",
              image: "",
            },
            {
              name: "Groen",
              image: "",
            },
            {
              name: "Rood",
              image: "",
            },
            {
              name: "Zwart",
              image: "",
            },
          ],
        },
        {
          name: "Merk",
          type: "checkbox",
          items: [
            {
              name: "Archetipo (Cleofe Finati)",
              image: "",
            },
            {
              name: "Goodmanners",
              image: "",
            },
            {
              name: "Immediate",
              image: "",
            },
            {
              name: "Javier Arnaiz",
              image: ""
            },
            {
              name: "Roberto Vicentti",
              image: "",
            }
          ],
        },
        {
          name: "Accessoires (bruidegom)",
          type: "checkbox",
          items: [
            {
              name: "Schoenen",
              image: "",
            },
            {
              name: "Riemen",
              image: "",
            },
            {
              name: "Dassen",
              image: "",
            },
            {
              name: "Vlinderdassen",
              image: "",
            },
            {
              name: "Juwelen",
              image: "",
            },
            {
              name: "Overig",
              image: "",
            },
          ],
        },
      ],
    },
    {
      name: "Gala",
      filterGroups: [
        {
          name: "Kleur",
          type: "checkbox",
          expanded: true,
          items: [
            {
              name: "Beige",
              image: "",
            },
            {
              name: "Blauw",
              image: "",
            },
            {
              name: "Geel",
              image: "",
            },
            {
              name: "Grijs",
              image: "",
            },
            {
              name: "Groen",
              image: "",
            },
            {
              name: "Oranje",
              image: "",
            },
            {
              name: "Paars",
              image: "",
            },
            {
              name: "Rood",
              image: "",
            },
            {
              name: "Roze",
              image: "",
            },
            {
              name: "Zilver",
              image: "",
            },
            {
              name: "Zwart",
              image: "",
            },
          ],
        },
        {
          name: "Merk",
          type: "checkbox",
          items: [
            {
              name: "Luxuar",
              image: "",
            },
            {
              name: "Maestri",
              image: "",
            },
            {
              name: "Nicole Moments",
              image: "",
            },
            {
              name: "Sonia Peña",
              image: "",
            },
            {
              name: "Christian Koehlert",
              image: "",
            },
            {
              name: "Mascara",
              image: "",
            },
            {
              name: "Frank Lyman",
              image: "",
            },
          ],
        },
      ],
    },
    {
      name: "Feestkleding",
      filterGroups: [
        {
          name: "Kleur",
          type: "checkbox",
          expanded: true,
          items: [
            {
              name: "Beige",
              image: "",
            },
            {
              name: "Blauw",
              image: "",
            },
            {
              name: "Geel",
              image: "",
            },
            {
              name: "Grijs",
              image: "",
            },
            {
              name: "Groen",
              image: "",
            },
            {
              name: "Oranje",
              image: "",
            },
            {
              name: "Paars",
              image: "",
            },
            {
              name: "Rood",
              image: "",
            },
            {
              name: "Roze",
              image: "",
            },
            {
              name: "Zilver",
              image: "",
            },
            {
              name: "Zwart",
              image: "",
            },
          ],
        },
        {
          name: "Merk",
          type: "checkbox",
          items: [
            {
              name: "Luxuar",
              image: "",
            },
            {
              name: "Maestri",
              image: "",
            },
            {
              name: "Nicole Moments",
              image: "",
            },
            {
              name: "Sonia Peña",
              image: "",
            },
            {
              name: "Christian Koehlert",
              image: "",
            },
            {
              name: "Mascara",
              image: "",
            },
            {
              name: "Frank Lyman",
              image: "",
            },
            {
              name: "Linea Raffaelli",
              image: "",
            },
            {
              name: "Joseph Ribkoff",
              image: "",
            }
          ],
        },
      ],
    },
  ],
};
